import { ChangeDetectionStrategy, Component } from '@angular/core';
import * as cee from '../../Common/CeeEnvisionWebComponents';
import { C3Service } from '../../c3.service';
import { PaneChild } from '../pane/pane.component';

@Component({
    selector: 'app-element-info',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './element-info.component.html',
    styleUrls: ['./element-info.component.css'],
    standalone: false
})
export class ElementInfoComponent extends PaneChild {
  private _c3Service: C3Service;
  private _hitItem!: cee.ug.HitItem;
  private _markupTrianglesPart: cee.mrk.PartIndexedTriangles;

  public get hitItem() {
    return this._hitItem;
  }

  public get anythingHit() {
    return this._hitItem && this._hitItem.anythingHit;
  }

  public get step() {
    if (this._hitItem.frameIndex > -1) {
      const states = this._c3Service._model['0'].modelDirectory.stateInfoArray;
      const state = states[this._hitItem.frameIndex];
      return `${state.name} (${this._hitItem.frameIndex + 1} of ${states.length}`;
    }
    return null;
  }

  public get coordinate() {
    const numDps = 9;

    if (this._hitItem.intersectionPoint) {
      return (
        this._hitItem.intersectionPoint.x.toFixed(numDps) +
        ' ' +
        this._hitItem.intersectionPoint.y.toFixed(numDps) +
        ' ' +
        this._hitItem.intersectionPoint.z.toFixed(numDps)
      );
    }
    return null;
  }

  public get hasElementResult() {
    return this._hitItem.elementResult !== undefined;
  }

  public get hasNodeResult() {
    return this._hitItem.nodeResult !== undefined;
  }

  public get elementResult() {
    if (this._hitItem.elementResult) {
      const interpolatedString = this._hitItem.elementResultIsInterpolated ? ' (interpolated)' : '';
      return `${this._hitItem.scalarResultName} = ${this._hitItem.elementResult.toPrecision(7)}${interpolatedString}`;
    }
    return null;
  }

  public get nodeResult() {
    if (this._hitItem.nodeResult) {
      const interpolatedString = this._hitItem.nodeResultIsInterpolated ? ' (interpolated)' : '';
      return `${this._hitItem.scalarResultName} = ${this._hitItem.nodeResult.toPrecision(7)}${interpolatedString}`;
    }
    return null;
  }

  public constructor(c3Service: C3Service) {
    super();
    this._c3Service = c3Service;

    const markupModel = new cee.mrk.MarkupModel();
    c3Service._view['0'].addModel(markupModel);
    this._markupTrianglesPart = markupModel.addIndexedTrianglesPart();

    c3Service.elementPicked['0'].subscribe((hitItem: cee.ug.HitItem) => {
      this._hitItem = hitItem;
      if (hitItem && hitItem.anythingHit) {
        this.show();
      } else {
        this.close();
      }

      if (hitItem.anythingHit) {
        this._markupTrianglesPart.setMeshData(hitItem.elementTriangleVertices, [0, 1, 2]);
      } else {
        this._markupTrianglesPart.setMeshData([], []);
      }
    });
  }

  public visibleChanged(value: boolean) {
    if (!value) {
      this._markupTrianglesPart.setMeshData([], []);
    }
  }
}
